export default __webpack_public_path__ + "static/media/vitalik_nft_6.252e09bf.svg";